import { useKeyboardEvents as m } from "../../../hooks/useKeyboardEvents.js";
import { MENU_ITEM as a } from "../../../constants/accessibilityAttributes.js";
const f = ({
  ref: c,
  onClick: r,
  disabled: i
}) => {
  m({
    ref: c,
    onEnter: () => {
      !i && r && r?.();
    },
    onArrowDown: (n) => {
      n?.preventDefault();
      const e = document.querySelectorAll(`[data-navigation="${a}"]`), t = Array.from(e).findIndex((o) => o === document.activeElement);
      t < e.length - 1 && e[t + 1].focus();
    },
    onArrowUp: (n) => {
      n?.preventDefault();
      const e = document.querySelectorAll(`[data-navigation="${a}"]`), t = Array.from(e).findIndex((o) => o === document.activeElement);
      t > 0 && e[t - 1].focus();
    }
  });
};
export {
  f as useMenuItemKeyboardNavigation
};
